// PORTED TO C# BY SEAN OTTEY
/**
 * To validate an email address according to RFCs 5321, 5322 and others
 * 
 * Copyright � 2008-2010, Dominic Sayers <br>
 * Test schema documentation Copyright � 2010, Daniel Marschall <br>
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 * 
 * - Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer. - Redistributions in binary
 * form must reproduce the above copyright notice, this list of conditions and
 * the following disclaimer in the documentation and/or other materials provided
 * with the distribution. - Neither the name of Dominic Sayers nor the names of
 * its contributors may be used to endorse or promote products derived from this
 * software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 * 
 * @package com.dominicsayers.isemail
 * @author Dominic Sayers <dominic@sayers.cc><br>
 *         Translated from PHP into Java by Daniel Marschall
 *         [www.daniel-marschall.de]
 * @copyright 2008-2010 Dominic Sayers; Java-Translation 2010 by Daniel
 *            Marschall
 * @license http://www.opensource.org/licenses/bsd-license.php BSD License
 * @link http://www.dominicsayers.com/isemail
 * @version 2010-10-18. Java-Translation of isemail.php:r68.
 */
export class EmailHelper {

    /**
     * Checks that an email address conforms to RFCs 5321, 5322 and others. With
     * verbose information.
     * 
     * @param email
     *            The email address to check
    */
    /*@param resultInfo disabled
    Validation check notification*/
    static isEmailValid (email: string/*, resultInfo*/) {
        //if (typeof resultInfo === "undefined" ||
        //    resultInfo === null)
        //{
        //    resultInfo = [];
        //}

        //if (Object.prototype.toString.call( resultInfo ) !== '[object Array]' )
        //{
        //    throw new Error('Invalid "resultInfo" parameter value: Array is expected');
        //}

        if (typeof email === 'undefined' || email == null) {
            email = '';
        }

        // Check that $email is a valid address. Read the following RFCs to
        // understand the constraints:
        // (http://tools.ietf.org/html/rfc5321)
        // (http://tools.ietf.org/html/rfc5322)
        // (http://tools.ietf.org/html/rfc4291#section-2.2)
        // (http://tools.ietf.org/html/rfc1123#section-2.1)
        // (http://tools.ietf.org/html/rfc3696) (guidance only)		

        // the upper limit on address lengths should normally be considered to
        // be 254
        // (http://www.rfc-editor.org/errata_search.php?rfc=3696)
        // NB My erratum has now been verified by the IETF so the correct answer
        // is 254
        //
        // The maximum total length of a reverse-path or forward-path is 256
        // characters (including the punctuation and element separators)
        // (http://tools.ietf.org/html/rfc5321#section-4.5.3.1.3)
        // NB There is a mandatory 2-character wrapper round the actual address
        var emailLength = email.length;
        // revision 1.17: Max length reduced to 254 (see above)
        if (emailLength > 254) {
            //resultInfo.push("\
            //    Email is too long.\
            //    The maximum total length of a reverse-path or forward-path is 256 \
            //                characters (including the punctuation and element separators)\
            //    (http://tools.ietf.org/html/rfc5321#section-4.5.3.1.3)");
            return false;
        }

        // Contemporary email addresses consist of a "local part" separated from
        // a "domain part" (a fully-qualified domain name) by an at-sign ("@").
        // (http://tools.ietf.org/html/rfc3696#section-3)
        var atIndex = email.lastIndexOf('@');

        if (atIndex == -1) {
            //resultInfo.push('\
            //    Email is too long.\
            //    Contemporary email addresses consist of a "local part" separated from\
            //    a "domain part" (a fully-qualified domain name) by an at-sign ("@").\
            //    (http://tools.ietf.org/html/rfc3696#section-3)');
            return false;
        }
        if (atIndex == 0) {
            //resultInfo.push('\
            //    Email is too long.\
            //    Contemporary email addresses consist of a "local part" separated from\
            //    a "domain part" (a fully-qualified domain name) by an at-sign ("@").\
            //    (http://tools.ietf.org/html/rfc3696#section-3)');
            return false;
        }
        if (atIndex == emailLength - 1) {
            //resultInfo.push('\
            //    Email is too long.\
            //    Contemporary email addresses consist of a "local part" separated from\
            //    a "domain part" (a fully-qualified domain name) by an at-sign ("@").\
            //    (http://tools.ietf.org/html/rfc3696#section-3)');
            return false;
        }

        // Sanitize comments
        // - remove nested comments, quotes and dots in comments
        // - remove parentheses and dots from quoted strings
        var braceDepth = 0;
        var inQuote = false;
        var escapeThisChar = false;

        for (var i = 0; i < emailLength; ++i) {
            var charX = email[i];
            var replaceChar = false;

            if (charX == '\\') {
                escapeThisChar = !escapeThisChar; // Escape the next character?
            } else {
                switch (charX) {
                    case '(':
                        if (escapeThisChar) {
                            replaceChar = true;
                        } else {
                            if (inQuote) {
                                replaceChar = true;
                            } else {
                                if (braceDepth++ > 0) {
                                    replaceChar = true; // Increment brace depth
                                }
                            }
                        }

                        break;
                    case ')':
                        if (escapeThisChar) {
                            replaceChar = true;
                        } else {
                            if (inQuote) {
                                replaceChar = true;
                            } else {
                                if (--braceDepth > 0)
                                    replaceChar = true; // Decrement brace depth
                                if (braceDepth < 0) {
                                    braceDepth = 0;
                                }
                            }
                        }

                        break;
                    case '"':
                        if (escapeThisChar) {
                            replaceChar = true;
                        } else {
                            if (braceDepth == 0) {
                                // Are we inside a quoted string?
                                inQuote = !inQuote;
                            } else {
                                replaceChar = true;
                            }
                        }

                        break;
                    case '.': // Dots don't help us either
                        if (escapeThisChar) {
                            replaceChar = true;
                        } else {
                            if (braceDepth > 0)
                                replaceChar = true;
                        }

                        break;
                }

                escapeThisChar = false;
                if (replaceChar) {
                    // Replace the offending character with something harmless
                    email = email.substring(0, i) + 'x' + email.substring(i + 1);
                }
            }
        }

        var localPart = email.substring(0, atIndex);
        var domain = email.substring(atIndex + 1);
        // Folding white space
        var FWS = "(?:(?:(?:[ \\t]*(?:\\r\\n))?[ \\t]+)|(?:[ \\t]+(?:(?:\\r\\n)[ \\t]+)*))";

        // Let's check the local part for RFC compliance...
        //
        // local-part = dot-atom / quoted-string / obs-local-part
        // obs-local-part = word *("." word)
        // (http://tools.ietf.org/html/rfc5322#section-3.4.1)
        //

        var regex = new RegExp("\\.(?=(?:[^\\\"]*\\\"[^\\\"]*\\\")*(?![^\\\"]*\\\"))");//removed (?m) at the beginning
        var dotArray = localPart.split(regex);
        var partLength = 0;

        for (var i = 0; i < dotArray.length; i++) {
            var element = dotArray[i];
            var working_element = element; // for use in our for loop, can't work on a foreach target SCO-04152011

            // Remove any leading or trailing FWS
            var repRegex = new RegExp("^" + FWS + "|" + FWS + "$");
            var new_element = working_element.replace(repRegex, '');

            if (working_element !== new_element) {
                // FWS is unlikely in the real world
                //    resultInfo.push(`\
                //    Folding White Space\
                //    local-part = dot-atom / quoted-string / obs-local-part\
                //    obs-local-part = word *("." word)\
                //(http://tools.ietf.org/html/rfc5322#section-3.4.1)`);
            }
            working_element = new_element;

            var elementLength = new_element.length;

            if (elementLength == 0) {
                // Can't have empty element (consecutive dots or
                // dots at the start or end)
                //resultInfo.push(@"
                //Can't have empty element (consecutive dots or
                //dots at the start or end)
                //(http://tools.ietf.org/html/rfc5322#section-3.4.1)
                //");
                return false;
            }

            // Remove any remaining leading or trailing FWS around the element
            // (having removed any comments)
            var fwsRegex = new RegExp("^" + FWS + "|" + FWS + "$");

            new_element = working_element.replace(fwsRegex, '');

            working_element = new_element;

            // What's left counts towards the maximum length for this part
            if (partLength > 0)
                partLength++; // for the dot
            partLength += working_element.length;

            // Each dot-delimited component can be an atom or a quoted string
            // (because of the obs-local-part provision)

            var quotRegex = /^"(?:[\s\S])*"$/;
            if (quotRegex.test(working_element)) //match.Count > 0
            {
                // Quoted-string tests:

                // Remove any FWS
                // A warning condition, but we've already raised
                // ISEMAIL_QUOTEDSTRING
                //var newRepRegex = new RegExp("(?<!\\\\)" + FWS);
                //working_element = working_element.replace(newRepRegex, '');

                // Remove all \\ from the string first...
                var slashRegex = new RegExp("\\\\\\\\");
                working_element = working_element.replace(slashRegex, '');

                var quot2Regex = new RegExp("\\\\\"$|\"\"");
                if (quot2Regex.test(working_element)) {
                    // ", CR, LF and NUL must be escaped
                    // version 2.0: allow ""@example.com because it's
                    // technically valid					
                    //resultInfo.push(@"
                    //        "", CR, LF and NUL must be escaped
                    //    ");
                    return false;
                } else {
                    //(?<!\\\\|^)[\"\\r\\n\\x00](?!$)|
                    var specChars = ['"', '\r', '\n', '\x00'];
                    for (var i1 = 0; i1 < specChars.length; i1++) {
                        var char = specChars[i1];
                        var checkString = working_element
                        var startIndex = 0;
                        var charIndex = checkString.indexOf(char);
                        while (charIndex != -1) {
                            if (charIndex != 0 && charIndex != checkString.length - 1) {
                                if (checkString[charIndex - 1] != '\\') {
                                    return false;
                                }
                            }

                            checkString = checkString.substring(charIndex + 1);
                            charIndex = checkString.indexOf(char);
                        }
                    }
                }
            } else {
                // Unquoted string tests:
                //
                // Period (".") may...appear, but may not be used to start or
                // end the
                // local part, nor may two or more consecutive periods appear.
                // (http://tools.ietf.org/html/rfc3696#section-3)
                //
                // A zero-length element implies a period at the beginning or
                // end of the
                // local part, or two periods together. Either way it's not
                // allowed.
                if (working_element == '') {
                    // Dots in wrong place
                    //resultInfo.push(@"
                    //    A zero-length element implies a period at the beginning or
                    //end of the local part, or two periods together. Either way it's not
                    //allowed.
                    //");
                    return false;
                }

                // Any ASCII graphic (printing) character other than the
                // at-sign ("@"), backslash, double quote, comma, or square
                // brackets may
                // appear without quoting. If any of that list of excluded
                // characters
                // are to appear, they must be quoted
                // (http://tools.ietf.org/html/rfc3696#section-3)
                //
                // Any excluded characters? i.e. 0x00-0x20, (, ), <, >, [, ], :,
                // ;, @, \, comma, period, "
                var quot3Regex = new RegExp("[\\x00-\\x20\\(\\)<>\\[\\]:;@\\\\,\\.\"]");
                if (quot3Regex.test(working_element)) //Matches(working_element).Count > 0
                {
                    // These characters must be in a quoted string
                    //resultInfo.push(@"
                    //     Any ASCII graphic (printing) character other than the
                    //     at-sign (""@""), backslash, double quote, comma, or square
                    //     brackets may appear without quoting. If any of that list of excluded
                    //     characters are to appear, they must be quoted
                    //     (http://tools.ietf.org/html/rfc3696#section-3)
                    //");
                    return false;
                }
            }
        }

        if (partLength > 64) {
            // Local part must be 64 characters or less
            //resultInfo.push(@"
            //    Local part must be 64 characters or less
            //");
            return false;
        }

        // Now let's check the domain part...

        // The domain name can also be replaced by an IP address in square
        // brackets
        // (http://tools.ietf.org/html/rfc3696#section-3)
        // (http://tools.ietf.org/html/rfc5321#section-4.1.3)
        // (http://tools.ietf.org/html/rfc4291#section-2.2)
        //
        // IPv4 is the default format for address literals. Alternative formats
        // can
        // be defined. At the time of writing only IPv6 has been defined as an
        // alternative format. Non-IPv4 formats must be tagged to show what type
        // of address literal they are. The registry of current tags is here:
        // http://www.iana.org/assignments/address-literal-tags

        if ((domain.match(/^\[(.)+]$/g) || []).length == 1) {
            //// It's an address-literal
            //// Quoted string is unlikely in the real world
            //return_status = IsEMailResult.ISEMAIL_ADDRESSLITERAL;

            // version 2.0: Warning condition added
            var addressLiteral = domain.substring(1, domain.length - 1);

            var IPv6;
            var groupMax = 8;

            var colon = ":";
            // IPv6 testing strategy
            var double_colon = "::";

            var IPv6tag = "IPv6:";

            // Extract IPv4 part from the end of the address-literal (if there
            // is one)
            var splitRegex = /\b(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

            var matchesIP1 = addressLiteral.match(splitRegex) || [];
            if (matchesIP1.length > 0) {
                var index = addressLiteral.lastIndexOf(matchesIP1[0]);

                if (index == 0) {
                    // Nothing there except a valid IPv4 address, so...
                    return true;
                }
                else {
                    // - // Assume it's an attempt at a mixed address (IPv6 +
                    // IPv4)
                    // - if ($addressLiteral[$index - 1] !== ':') return
                    // IsEMailResult.ISEMAIL_IPV4BADPREFIX; // Character
                    // preceding IPv4 address must be ':'
                    // revision 2.1: new IPv6 testing strategy
                    if (addressLiteral.substring(0, 5) !== IPv6tag) {
                        // RFC5321 section 4.1.3		
                        //resultInfo.push(@"
                        //    Character preceding IPv4 address must be ':'
                        //    RFC5321 section 4.1.3	
                        //");
                        return false;
                    }

                    IPv6 = addressLiteral.substring(5, index) + "0000:0000"; // Convert IPv4 part to IPv6 format
                }
            }
            else {
                // It must be an attempt at pure IPv6
                if (addressLiteral.substring(0, 5) !== IPv6tag) {
                    // RFC5321 section 4.1.3
                    //resultInfo.push(@"
                    //        Invalid IPV6 address
                    //        RFC5321 section 4.1.3	
                    //    ");
                    return false;
                }
                IPv6 = addressLiteral.substring(5);
            }

            var split2Regex = new RegExp(colon);
            var matchesIP = IPv6.split(split2Regex);
            var groupCount = matchesIP.length;
            var currIndex = IPv6.indexOf(double_colon);

            if (currIndex == -1) {
                // We need exactly the right number of groups
                if (groupCount !== groupMax) {
                    // RFC5321 section 4.1.3
                    //resultInfo.push(@"
                    //        Invalid IPV6 groupcount
                    //        RFC5321 section 4.1.3	
                    //    ");
                    return false;
                }
            } else {
                if (currIndex !== IPv6.lastIndexOf(double_colon)) {
                    // More than one '::'
                    //resultInfo.push(@"
                    //        IPV6 double double colon present
                    //        RFC5321 section 4.1.3	
                    //    ");
                    return false;
                }
                if ((currIndex === 0) || (currIndex === (IPv6.length - 2))) {
                    groupMax++; // RFC 4291 allows :: at the start or end of an
                }
                // address with 7 other groups in addition
                if (groupCount > groupMax) {
                    // Too many IPv6 groups in address
                    //resultInfo.push(@"
                    //        Too many groups in section
                    //        RFC5321 section 4.1.3	
                    //    ");
                    return false;
                }
                if (groupCount === groupMax) {
                    // Eliding a single group with :: is deprecated by RFCs 5321 & 5952
                    // & 5952
                    //resultInfo.push(@"Eliding a single group with :: is deprecated by RFCs 5321 & 5952");
                }
            }

            // Check for single : at start and end of address
            if (IPv6.startsWith(colon) && (!IPv6.startsWith(double_colon))) {
                // Address starts with a single colon
                //resultInfo.push(@"
                //    IPV6 must start with a single colon
                //    RFC5321 section 4.1.3	
                //        ");
                return false;
            }
            if (IPv6.endsWith(colon) && (!IPv6.endsWith(double_colon))) {
                // Address ends with a single colon
                //resultInfo.push(@"
                //    IPV6 must end with a single colon
                //    RFC5321 section 4.1.3	
                //        ");
                return false;
            }

            // Check for unmatched characters
            for (var i2 = 0; i2 < matchesIP.length; i2++) {
                var s = matchesIP[i2];
                var goodStuff = new RegExp("^[0-9A-Fa-f]{0,4}$");
                if (goodStuff.test(s)) {
                    //resultInfo.push(@"
                    //IPV6 address contains bad characters
                    //RFC5321 section 4.1.3	
                    //    ");
                    return false;
                }
            }

            // It's a valid IPv6 address, so...
            return true;

        }
        else {
            // It's a domain name...

            // The syntax of a legal Internet host name was specified in RFC-952
            // One aspect of host name syntax is hereby changed: the
            // restriction on the first character is relaxed to allow either a
            // letter or a digit.
            // (http://tools.ietf.org/html/rfc1123#section-2.1)
            //
            // NB RFC 1123 updates RFC 1035, but this is not currently apparent
            // from reading RFC 1035.
            //
            // Most common applications, including email and the Web, will
            // generally not
            // permit...escaped strings
            // (http://tools.ietf.org/html/rfc3696#section-2)
            //
            // the better strategy has now become to make the
            // "at least one period" test,
            // to verify LDH conformance (including verification that the
            // apparent TLD name
            // is not all-numeric)
            // (http://tools.ietf.org/html/rfc3696#section-2)
            //
            // Characters outside the set of alphabetic characters, digits, and
            // hyphen MUST NOT appear in domain name
            // labels for SMTP clients or servers
            // (http://tools.ietf.org/html/rfc5321#section-4.1.2)
            //
            // RFC5321 precludes the use of a trailing dot in a domain name for
            // SMTP purposes
            // (http://tools.ietf.org/html/rfc5321#section-4.1.2)

            var split2Regex = new RegExp("\\.(?=(?:[^\\\"]*\\\"[^\\\"]*\\\")*(?![^\\\"]*\\\"))");//(?m)
            dotArray = domain.split(split2Regex);
            partLength = 0;
            // Since we use 'element' after the foreach
            // loop let's make sure it has a value
            var lastElement = "";

            if (dotArray.length == 1) {
                //resultInfo.push(@"The mail host probably isn't a TLD");                
            }

            for (var i3 = 0; i3 < dotArray.length; i3++) {
                var element = dotArray[i3];
                var working_element = element;
                lastElement = element;
                // Remove any leading or trailing FWS
                var newReg = new RegExp("^" + FWS + "|" + FWS + "$");
                var new_element = working_element.replace(newReg, "");

                if (element !== new_element) {
                    //resultInfo.push(@"FWS is unlikely in the real world");                    
                }
                working_element = new_element;

                var elementLength = working_element.length;

                // Each dot-delimited component must be of type atext
                // A zero-length element implies a period at the beginning or
                // end of the
                // local part, or two periods together. Either way it's not
                // allowed.
                if (elementLength == 0) {
                    // Dots in wrong place
                    //   resultInfo.push(@"
                    //Each dot-delimited component must be of type atext
                    //   A zero-length element implies a period at the beginning or
                    //   end of the
                    //   local part, or two periods together. Either way it's not
                    //   allowed.
                    //   ");
                    return false;
                }

                // Remove any leading or trailing FWS around the element (inside
                // any comments)
                var repRegex = new RegExp("^" + FWS + "|" + FWS + "$");
                new_element = working_element.replace(repRegex, '');

                working_element = new_element;

                // What's left counts towards the maximum length for this part
                if (partLength > 0) {
                    partLength++; // for the dot
                }

                partLength += working_element.length;

                // The DNS defines domain name syntax very generally -- a
                // string of labels each containing up to 63 8-bit octets,
                // separated by dots, and with a maximum total of 255
                // octets.
                // (http://tools.ietf.org/html/rfc1123#section-6.1.3.5)
                if (elementLength > 63) {
                    // Label must be 63 characters or less
                    //   resultInfo.push(@"
                    //The DNS defines domain name syntax very generally -- a
                    //string of labels each containing up to 63 8-bit octets,
                    //separated by dots, and with a maximum total of 255
                    //   octets.
                    //   (http://tools.ietf.org/html/rfc1123#section-6.1.3.5)
                    //   ");
                    return false;
                }

                // Any ASCII graphic (printing) character other than the
                // at-sign ("@"), backslash, double quote, comma, or square
                // brackets may
                // appear without quoting. If any of that list of excluded
                // characters
                // are to appear, they must be quoted
                // (http://tools.ietf.org/html/rfc3696#section-3)
                //
                // If the hyphen is used, it is not permitted to appear at
                // either the beginning or end of a label.
                // (http://tools.ietf.org/html/rfc3696#section-2)
                //
                // Any excluded characters? i.e. 0x00-0x20, (, ), <, >, [, ], :,
                // ;, @, \, comma, period, "

                var badChars = new RegExp("[\\x00-\\x20\\(\\)<>\\[\\]:;@\\\\,\\.\"]|^-|-$");
                if (badChars.test(working_element))//.Matches(working_element).Count > 0
                {
                    // Illegal character in domain name
                    //resultInfo.push(@"
                    //Illegal character in domain name
                    //    ");
                    return false;
                }
            }

            if (partLength > 255) {
                // Domain part must be 255 characters or less
                // (http://tools.ietf.org/html/rfc1123#section-6.1.3.5)
                //resultInfo.push(@"
                // Domain part must be 255 characters or less
                // (http://tools.ietf.org/html/rfc1123#section-6.1.3.5)
                //");
                return false;
            }

            var foo = new RegExp("^[0-9]+$");
            if (foo.test(lastElement))//Matches(lastElement).Count > 0
            {
                //resultInfo.push(@"TLD probably isn't all-numeric
                //(http://www.apps.ietf.org/rfc/rfc3696.html#sec-2)
                //");
                return false;
            }
        }

        return true;
    }
}